import {http} from '@/http'
import { Util } from "@wizepe/wize-admin";

export default {
  login(payload) {
    const formData = Util.getFormData(payload);
    return http.post('/api/v1/admin/auth', formData, {headers: { "Content-Type": "multipart/form-data" },})
  },
  isValidToken() {
    return http.get('/api/v1/admin/auth/token')
  },
  recoverPassword(data) {
    return http.put('/api/v1/admin/auth/password', data)
  },
  resetPassword(data) {
    return http.post('/api/v1/admin/auth/password', data)
  }
}
